/* OMNÉA Produktbühne (22.10.2026) – Scroll-Szenen für sections/omnea-buehne.liquid, ohne Fremdbibliothek.
   Ablauf (Zeitachse in Szenen-Einheiten): [ganze Bühne: Karussell -> Farbraum] -> Merkmal 1-4 mit Drehung -> Ausklang.
   Scrollen bestimmt die Zielzeit, die Anzeige läuft weich hinterher. */
(function () {
  'use strict';

  var EASE = {
    none: function (p) { return p; },
    rein: function (p) { return p * p; },
    raus: function (p) { return 1 - (1 - p) * (1 - p); },
    weich: function (p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
  };
  var EINHEIT = { '--tilt': 'deg', '--r1': 'deg', '--r2': 'deg', '--r3': 'deg', '--r4': 'deg', '--x': 'px', '--y': 'px', '--s1': '%', '--s2': '%', '--s3': '%', '--s4': '%' };
  // Merkmal-Punkte: Ansicht, Lage in % der Ansicht, Zoom (breit / schmal)
  var MERKMALE = [
    { v: 'obn-v1', hx: 50, hy: 11.5, s: [2.0, 1.75] },
    { v: 'obn-v2', hx: 39, hy: 62, s: [1.6, 1.45] },
    { v: 'obn-v3', hx: 62, hy: 27, s: [1.8, 1.6] },
    { v: 'obn-v4', hx: 55, hy: 20, s: [1.95, 1.7] }
  ];

  function klemme(v, a, b) { return v < a ? a : v > b ? b : v; }

  function starte(root) {
    var voll = root.getAttribute('data-modus') === 'voll';
    var buehne = root.querySelector('.obn-buehne');
    var spur = root.querySelector('.obn-spur');
    var karussell = root.querySelector('.obn-karussell');
    var figuren = Array.prototype.slice.call(root.querySelectorAll('.obn-figur'));

    // 24.10.2026: Bilder der übrigen Farben (data-obn-src) erst nachladen, wenn die Seite fertig geladen ist und die
    // Bühne in die Nähe kommt (1 Bildschirmhöhe vorher) – oder sofort, sobald jemand eine Farbe antippt.
    var nachgeladen = false;
    function nachladen() {
      if (nachgeladen) return;
      nachgeladen = true;
      root.querySelectorAll('img[data-obn-src]').forEach(function (i) { i.loading = 'eager'; i.src = i.getAttribute('data-obn-src'); i.removeAttribute('data-obn-src'); });
    }
    if (root.querySelector('img[data-obn-src]')) {
      root.addEventListener('pointerdown', nachladen, { once: true });
      root.addEventListener('keydown', nachladen, { once: true });
      var nah = false, geladen = document.readyState === 'complete';
      var pruefen = function () { if (nah && geladen) nachladen(); };
      if (!geladen) window.addEventListener('load', function () { geladen = true; pruefen(); }, { once: true });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) {
          if (e[0].isIntersecting) { nah = true; io.disconnect(); pruefen(); }
        }, { rootMargin: '100% 0px' });
        io.observe(root);
      } else { nah = true; pruefen(); }
    }
    var merkmale = Array.prototype.slice.call(root.querySelectorAll('.obn-merkmal'));
    var navKnoepfe = Array.prototype.slice.call(root.querySelectorAll('.obn-nav button'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.obn-chip'));
    var ende = root.querySelector('.obn-ende');
    var punkt = root.querySelector('.obn-punkt');
    var linie = root.querySelector('.obn-linie');
    var daten = [];
    try { daten = JSON.parse(root.querySelector('.obn-json').textContent); } catch (e) { return; }
    if (!figuren.length || !buehne || !spur) return;
    var aktiv = voll ? klemme((parseInt(root.getAttribute('data-start'), 10) || 1) - 1, 0, figuren.length - 1) : 0;
    var wechselZeit = 0;

    /* ---------- Farbe ---------- */
    function setzeFarbe(i, animiert) {
      var n = figuren.length, h = Math.floor(n / 2);
      var vorher = aktiv;
      aktiv = ((i % n) + n) % n;
      if (animiert && karussell) {
        karussell.classList.add('obn-wechsel');
        // Die bisherige Figur behält beim Hinausfliegen ihre aktuelle Ansicht (kein Sprung auf vorne)
        figuren.forEach(function (f) { f.classList.remove('obn-raus'); });
        if (vorher !== aktiv && figuren[vorher]) figuren[vorher].classList.add('obn-raus');
        clearTimeout(wechselZeit);
        wechselZeit = setTimeout(function () {
          karussell.classList.remove('obn-wechsel');
          figuren.forEach(function (f) { f.classList.remove('obn-raus'); });
        }, 1000);
      }
      figuren.forEach(function (f, j) {
        var k = ((j - aktiv + n + h) % n) - h;
        f.style.setProperty('--k', k);
        f.style.setProperty('--ak', Math.abs(k));
        f.classList.toggle('obn-aktiv', k === 0);
        f.style.zIndex = k === 0 ? 3 : 2 - Math.abs(k);
        if (f.tagName === 'BUTTON') f.setAttribute('aria-pressed', k === 0 ? 'true' : 'false');
      });
      var F = daten[aktiv] || {};
      root.style.setProperty('--c', F.licht);
      root.querySelectorAll('[data-obn="farbname"]').forEach(function (el) { el.textContent = F.name; });
      root.querySelectorAll('[data-obn="kurzname"]').forEach(function (el) { el.textContent = F.kurz; });
      root.querySelectorAll('[data-obn="shop"]').forEach(function (el) { el.href = F.url; });
      chips.forEach(function (c, j) { c.setAttribute('aria-pressed', j === aktiv ? 'true' : 'false'); });
      if (zeitachse) baue();
    }

    if (voll) {
      figuren.forEach(function (f, j) { f.addEventListener('click', function () { if (j !== aktiv) setzeFarbe(j, true); }); });
      chips.forEach(function (c, j) { c.addEventListener('click', function () { setzeFarbe(j, true); }); });
      var z = root.querySelector('.obn-zurueck'), w = root.querySelector('.obn-weiter');
      if (z) z.addEventListener('click', function () { setzeFarbe(aktiv - 1, true); });
      if (w) w.addEventListener('click', function () { setzeFarbe(aktiv + 1, true); });
      var sx = 0, sy = 0;
      buehne.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      buehne.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) setzeFarbe(aktiv + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!sichtbar || (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName))) return;
        var r = buehne.getBoundingClientRect();
        if (r.top > 4 || r.bottom < window.innerHeight * 0.6) return;
        if (e.key === 'ArrowLeft') setzeFarbe(aktiv - 1, true);
        if (e.key === 'ArrowRight') setzeFarbe(aktiv + 1, true);
      });
    }

    var zeitachse = null;
    // Ganze Bühne ganz oben auf der Seite: Startansicht auf den Bereich unter der Shop-Kopfzeile abstimmen
    function kopfMessen() {
      if (!voll) return;
      var oben = root.getBoundingClientRect().top + window.pageYOffset;
      root.style.setProperty('--unten', (oben > 0 && oben < window.innerHeight * 0.6 ? Math.round(oben) : 0) + 'px');
    }
    kopfMessen();
    setzeFarbe(aktiv, false);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('obn--js');

    /* ---------- Zeitachse ---------- */
    var START = voll
      ? { '--zoom': 1, '--tilt': 0, '--x': 0, '--y': 0, '--seiten': 1, '--glut': 0, '--fokus': 0, '--nav': 0, '--ende': 0 }
      : { '--zoom': 1.1, '--tilt': -7, '--x': 0, '--y': 0, '--seiten': 0, '--glut': 1, '--fokus': 1, '--nav': 0, '--ende': 0 };
    START['--v1'] = 1; START['--v2'] = 0; START['--v3'] = 0; START['--v4'] = 0;
    START['--r1'] = 0; START['--r2'] = -64; START['--r3'] = -64; START['--r4'] = -64;
    START['--s1'] = 0; START['--s2'] = 0; START['--s3'] = 0; START['--s4'] = 0;
    var labels = {}, dauer = 1, gruppen = {}, zuletzt = {};

    function ziel(m, breit) {
      var W = buehne.clientWidth, H = buehne.clientHeight;
      var fig = figuren[aktiv];
      var view = fig.querySelector('.' + m.v);
      var s = m.s[breit ? 0 : 1];
      var dx = (m.hx / 100 - 0.5) * view.offsetWidth;
      var dy = (m.hy / 100 - 0.5) * fig.offsetHeight;
      var cy = fig.offsetTop + fig.offsetHeight / 2;
      var tx = breit ? W * 0.63 : W * 0.5;
      var ty = breit ? H * 0.5 : H * 0.4;
      return { s: s, x: tx - W / 2 - s * dx, y: ty - cy - s * dy };
    }

    function baue() {
      var breit = window.innerWidth > 700;
      var W = buehne.clientWidth, H = buehne.clientHeight;
      var liste = [];
      function tw(prop, s, d, to, ease, el) { liste.push({ p: prop, s: s, d: d, to: to, e: EASE[ease || 'weich'], el: el || null }); }
      function hold(t, d) { return t + d; }
      var t;
      if (voll) {
        tw('--seiten', 0.35, 1.2, 0); tw('--glut', 0.35, 1.2, 1); tw('--fokus', 0.35, 1.2, 1);
        tw('--zoom', 0.35, 1.2, breit ? 1.1 : 1.04); tw('--tilt', 0.35, 1.2, -7);
        tw('--x', 0.35, 1.2, breit ? W * 0.14 : 0); tw('--y', 0.35, 1.2, breit ? 0 : H * 0.07);
        t = hold(1.55, 0.6);
      } else {
        START['--x'] = breit ? W * 0.14 : 0; START['--y'] = breit ? 0 : H * 0.07; START['--zoom'] = breit ? 1.1 : 1.04;
        t = 0.45;
      }
      // Merkmal 1: Bund (vorne)
      labels.m1 = t;
      var z0 = ziel(MERKMALE[0], breit);
      tw('--fokus', t, 1.1, 0); tw('--tilt', t, 1.1, 0); tw('--zoom', t, 1.1, z0.s); tw('--x', t, 1.1, z0.x); tw('--y', t, 1.1, z0.y); tw('--nav', t, 1.1, 1);
      tw('op', t + 0.6, 0.5, 1, 'weich', merkmale[0]);
      tw('--s1', t + 0.7, 1.1, 100, 'none');
      t = hold(t + 1.8, 0.6);
      // Merkmal 2-4: drehen, im Profil Ansicht tauschen, zoomen
      for (var i = 1; i < 4; i++) {
        var a = i, b = i + 1, z = ziel(MERKMALE[i], breit);
        labels['m' + b] = t;
        tw('op', t, 0.35, 0, 'weich', merkmale[i - 1]);
        tw('--zoom', t, 1.1, z.s); tw('--x', t, 1.1, z.x); tw('--y', t, 1.1, z.y);
        tw('--r' + a, t, 0.5, 64, 'rein');
        tw('--v' + a, t + 0.47, 0.06, 0, 'none'); tw('--v' + b, t + 0.47, 0.06, 1, 'none');
        tw('--r' + b, t + 0.5, 0.55, 0, 'raus');
        tw('op', t + 0.65, 0.5, 1, 'weich', merkmale[i]);
        tw('--s' + b, t + 0.75, 1.1, 100, 'none');
        t = hold(t + 1.85, 0.6);
      }
      // Ausklang: zurück nach vorne
      labels.aus = t;
      tw('op', t, 0.35, 0, 'weich', merkmale[3]);
      tw('--r1', t, 0, -64);
      tw('--zoom', t, 1.2, 1); tw('--x', t, 1.2, 0); tw('--y', t, 1.2, 0); tw('--nav', t, 1.2, 0);
      tw('--r4', t, 0.5, 64, 'rein');
      tw('--v4', t + 0.47, 0.06, 0, 'none'); tw('--v1', t + 0.47, 0.06, 1, 'none');
      tw('--r1', t + 0.5, 0.55, 0, 'raus');
      if (voll) {
        tw('--glut', t, 1.2, 0.55);
        tw('--seiten', t + 0.6, 0.8, 1, 'raus');
        dauer = t + 1.7;
      } else {
        tw('--fokus', t + 0.7, 0.6, 1); tw('--ende', t + 0.7, 0.6, 1);
        dauer = t + 1.6;
      }
      // je Eigenschaft der Reihe nach; Startwert jedes Übergangs = Endwert des vorigen
      gruppen = {};
      liste.forEach(function (x, n) {
        var key = x.el ? 'op' + merkmale.indexOf(x.el) : x.p;
        (gruppen[key] = gruppen[key] || { el: x.el, p: x.p, liste: [] }).liste.push(x);
      });
      Object.keys(gruppen).forEach(function (key) {
        var g = gruppen[key];
        g.liste.sort(function (a, b) { return a.s - b.s; });
        var vorher = g.el ? 0 : START[g.p];
        g.start = vorher;
        g.liste.forEach(function (x) { x.von = vorher; vorher = x.to; });
      });
      zuletzt = {};
      anwenden(aktuell, true);
    }

    function wertBei(g, t) {
      var v = g.start;
      for (var i = 0; i < g.liste.length; i++) {
        var x = g.liste[i];
        if (t < x.s) break;
        if (x.d === 0 || t >= x.s + x.d) { v = x.to; continue; }
        v = x.von + (x.to - x.von) * x.e(klemme((t - x.s) / x.d, 0, 1));
        break;
      }
      return v;
    }

    var opWerte = [0, 0, 0, 0];
    function anwenden(t, alles) {
      // Eigenschaften ohne Übergang auf Startwert halten
      Object.keys(START).forEach(function (p) {
        var v = gruppen[p] ? wertBei(gruppen[p], t) : START[p];
        var s = (Math.round(v * 1000) / 1000) + (EINHEIT[p] || '');
        if (alles || zuletzt[p] !== s) { buehne.style.setProperty(p, s); zuletzt[p] = s; }
      });
      merkmale.forEach(function (el, i) {
        var g = gruppen['op' + i];
        var v = g ? wertBei(g, t) : 0;
        opWerte[i] = v;
        var s = String(Math.round(v * 1000) / 1000);
        if (alles || zuletzt['op' + i] !== s) {
          el.style.opacity = s;
          el.style.visibility = v > 0.001 ? 'visible' : 'hidden';
          zuletzt['op' + i] = s;
        }
      });
      if (ende) ende.classList.toggle('obn-sichtbar', parseFloat(zuletzt['--ende']) > 0.02);
    }

    function zeichnen() {
      var best = -1, bestA = 0;
      opWerte.forEach(function (a, i) { if (a > bestA) { bestA = a; best = i; } });
      navKnoepfe.forEach(function (b, i) { b.classList.toggle('obn-an', i === best && bestA > 0.5); });
      if (!punkt) return;
      // Während eines Farbwechsels fliegt die neue Figur erst herein: Punkt und Linie solange aus
      if (karussell && karussell.classList.contains('obn-wechsel')) { punkt.style.opacity = 0; if (linie) linie.style.opacity = 0; return; }
      if (best < 0 || bestA < 0.02) { punkt.style.opacity = 0; if (linie) linie.style.opacity = 0; return; }
      var anker = figuren[aktiv].querySelector('.obn-anker[data-m="' + (best + 1) + '"]');
      if (!anker) return;
      var b = buehne.getBoundingClientRect(), r = anker.getBoundingClientRect();
      var px = r.left - b.left, py = r.top - b.top;
      punkt.style.transform = 'translate(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px)';
      punkt.style.opacity = bestA;
      if (!linie) return;
      var h = merkmale[best].querySelector('.obn-schlag').getBoundingClientRect();
      var lx = h.right - b.left + 24, ly = h.top - b.top + h.height * 0.5;
      var knick = Math.max(lx + 20, px - 70);
      linie.setAttribute('points', lx.toFixed(1) + ',' + ly.toFixed(1) + ' ' + knick.toFixed(1) + ',' + ly.toFixed(1) + ' ' + (px - 10).toFixed(1) + ',' + py.toFixed(1));
      linie.style.opacity = bestA * 0.7;
    }

    /* ---------- Scrollen -> Zeit ---------- */
    var aktuell = 0, zielZeit = 0, letzte = 0, sichtbar = false, laeuft = false;
    function weg() { return Math.max(1, spur.offsetHeight - buehne.offsetHeight); }
    function zielAusScroll() {
      var p = klemme(-spur.getBoundingClientRect().top / weg(), 0, 1);
      zielZeit = p * dauer;
    }
    function tick(jetzt) {
      var dt = Math.min(64, jetzt - (letzte || jetzt));
      letzte = jetzt;
      zielAusScroll();
      aktuell += (zielZeit - aktuell) * (1 - Math.exp(-dt / 140));
      if (Math.abs(zielZeit - aktuell) < 0.0008) aktuell = zielZeit;
      anwenden(aktuell, false);
      zeichnen();
      if (sichtbar || aktuell !== zielZeit) requestAnimationFrame(tick);
      else { laeuft = false; letzte = 0; }
    }
    function los() { if (!laeuft) { laeuft = true; requestAnimationFrame(tick); } }

    navKnoepfe.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var t = labels['m' + (i + 1)] + 1.35;
        var oben = spur.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: oben + weg() * (t / dauer), behavior: 'smooth' });
      });
    });
    root.querySelectorAll('[data-obn="zur-auswahl"]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ziel = document.querySelector('product-form, form[action*="/cart/add"]');
        if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    var rz = 0;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { kopfMessen(); baue(); los(); }, 150); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sichtbar = e[0].isIntersecting;
        if (sichtbar) los();
      }, { rootMargin: '200px 0px' }).observe(root);
    } else { sichtbar = true; }

    zeitachse = true;
    baue();
    zielAusScroll(); aktuell = zielZeit;
    anwenden(aktuell, true);
    los();
    window.addEventListener('load', function () { baue(); los(); });
  }

  function alle() {
    document.querySelectorAll('.obn:not([data-obn-bereit])').forEach(function (root) {
      root.setAttribute('data-obn-bereit', '');
      starte(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
